import type { ReactNode } from 'react';

import { ErrorRounded } from '@mui/icons-material';
interface Props {
  children: ReactNode;
  label?: string;
}

export const HuddlePrintoutIndicator = ({ children, label }: Props) => (
  <div>
    <div className="vai-flex vai-items-center vai-gap-1">
      <ErrorRounded className="vai-fill-slate-400" fontSize="small" />
      {label && <p className="vai-typography-p !vai-leading-5">{label}</p>}
    </div>
    <div className="vai-ml-7">{children}</div>
  </div>
);
